/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgListFolder = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <style>{'.ico-list-folder_svg__st0{fill:currentcolor}'}</style>
    <path
      className="ico-list-folder_svg__st0"
      d="M13 16c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 4c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm5-2h4v2h-4z"
    />
    <path className="ico-list-folder_svg__st0" d="m12.6 6-2-4H2v20h6v-2H4V4h5.4l2 4H20v8h2V6z" />
  </Icon>
);
export { SvgListFolder as ListFolder };
